import Icon from "../../common/Icon";
import mealImage from "../../../assets/images/mealImage.png";
import alert from "../../../assets/images/alert.png";
import DayMealHolder from "./DayMealHolder";
import { useNavigate } from "react-router-dom";
import ContainerLoading from "../../common/loading/ContainerLoading";
import FullScreenLoading from "../../common/loading/FullScreenLoading";
import { isMealCustomizationPending, isSnack } from "../../utils/commonHelper";
import { useGeneral } from "../../contexts/GeneralContext";

const CustomizeMeal = ({
  meal,
  activeWeek,
  setActiveWeek,
  loading,
  onUpdateMeals,
}) => {
  const navigate = useNavigate();
  const { extraContent } = useGeneral();
  return (
    <div className=" w-full mt-4 lg:mt-6 rounded-[15px]">
      <div className="grid lg:grid-cols-2 gap-4 lg:gap-8">
        <div className="bg-[#CFD4CD]/20 flex items-center justify-start rounded-[15px] p-3">
          <div className="w-[56px] h-[56px]  sm:w-[96px] sm:h-[96px] bg-[#fff] border border-[#DEE2DD] rounded-full flex items-center justify-center me-4 relative">
            <Icon
              icon="profile"
              className={`w-[37px] h-[50px] sm:w-[57px] sm:h-[60px] ${
                meal?.kid?.gender.toLowerCase() === "girl"
                  ? "text-[#FC05B0]/40"
                  : "text-[#0B81FD]/40"
              }`}
            />
          </div>

          <div className="flex flex-1 flex-col items-start justify-start">
            <p className="text-24pt leading-light">
              {meal?.kid?.firstName} {meal?.kid?.lastName}
            </p>
            <p className="text-18pt">
              ({meal?.kid?.gender} - {meal?.kid?.age} years old)
            </p>
          </div>

          <div
            title="Click to edit child details"
            className="me-2 cursor-pointer"
            onClick={() =>
              navigate(`/account/profile/edit-child/${meal?.kid?._id}`)
            }
          >
            <Icon
              icon="edit"
              className="w-7 h-7 text-green hover:text-secondary"
            />
          </div>
        </div>

        <div className="bg-[#CFD4CD]/20 flex items-center justify-start rounded-[15px] p-3">
          <div className=" flex items-center justify-center me-4 relative">
            <img
              src={mealImage}
              className={`w-[100px] md:w-[90px] h-auto object-contain`}
            />
          </div>
          <div className="w-full">
             <div className="flex flex-col items-start justify-start xl:w-full">
            <p className="text-21pt 2xl:text-24pt leading-tight uppercase">
              {meal?.plan?.title} plan - ({meal?.totalMealsInPlan} days meals)
            </p>
            <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between flex-wrap xl:w-full">
              <p className="text-18pt text-quaternary me-2">
                {meal?.subscribedMeals?.length > 0
                  ? meal.subscribedMeals
                      .map((m) =>
                        isSnack(m?.meal?.title) ? "Snacks" : m?.meal?.title
                      )
                      .join(" + ")
                  : "None selected"}
              </p>
              <p className="me-2">
                {" "}
                <span
                  className={`px-2 py-0.5 font-mono text-[12px] rounded-[5px] text-xs xl:whitespace-nowrap ${
                    meal?.vegOrNonVeg === "Veg"
                      ? "bg-quaternary text-white"
                      : "bg-orange text-secondary text-white"
                  }`}
                >
                  {meal?.vegOrNonVeg}
                </span>
              </p>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 mt-4 2xl:mt-6 relative">
        <div className="bg-[#CFD4CD]/20 flex flex-col items-start justify-start rounded-[15px] px-4 2.5xl:px-[90px] py-4 2.5xl:py-10 2.5xl:py-12">
          <p className="text-green text-21pt">
            Customize Meals ({meal?.totalMealsInPlan} days meals)
          </p>
          {loading && <FullScreenLoading />}
          <div
            className={
              isMealCustomizationPending(meal)
                ? "grid 2.5xl:grid-cols-[2.7fr_1fr] gap-4 w-full relative"
                : "grid grid-cols-1 gap-4 w-full"
            }
          >
            <div className="order-2 2.5xl:order-1">
              <div className="flex flex-col md:flex-row mt-4  2.5xl:mt-11 gap-4">
                {meal?.tabHeadings.map((week, index) => (
                  <div
                    key={index}
                    title={`Click to customize meals for week ${week.week}`}
                    onClick={() => setActiveWeek(week.week)}
                    className={`${
                      String(activeWeek) === String(week.week)
                        ? "bg-[#CFD4CD]"
                        : "bg-[#CFD4CD]/40"
                    } lg:h-[66px] 2.5xl:min-w-[427px] hover:bg-[#CFD4CD] rounded-[15px] flex items-center justify-center 
              text-16pt xs:text-18pt lg:text-24pt 2.5xl:text-30pt px-3 py-1 lg:p-4 2.5xl:px-4 cursor-pointer text-nowrap`}
                  >
                    {week.week === 1 ? "Current Week" : "Next Week"} (
                    {week.dates})
                  </div>
                ))}
              </div>

              <div className="mt-12  w-full">
                <DayMealHolder
                  activeWeek={activeWeek}
                  customize={meal}
                  onUpdateMeals={onUpdateMeals}
                  paused={meal?.paused}
                />
              </div>
            </div>

            {isMealCustomizationPending(meal) &&
              (extraContent?.mealCustomizationMessages?.line_1 ||
                extraContent?.mealCustomizationMessages?.line_2) && (
                <div className="relative order-1 2.5xl:order-2 mt-4 ">
                  <div className="2xl:sticky 2.5xl:top-[180px] w-full rounded-[15px] 2.5xl:mt-[142px] bg-secondary overflow-y-auto">
                    <div className="2.5xl:min-h-[254px] ps-8 pe-8 py-6 relative">
                      <div className="2xl:min-w-[208px]">
                        <p className="text-white text-18pt mb-4">
                          Please note:
                        </p>
                        {extraContent?.mealCustomizationMessages?.line_1 && (
                          <p className="text-white text-16pt font-mono mb-4">
                            {extraContent?.mealCustomizationMessages?.line_1}
                          </p>
                        )}
                        {extraContent?.mealCustomizationMessages?.line_2 && (
                          <p className="text-white text-16pt font-mono">
                            {extraContent?.mealCustomizationMessages?.line_2}
                          </p>
                        )}
                      </div>
                      <img
                        src={alert}
                        className="absolute w-[30px] md:w-[49px] lg:w-[30px] 2.5xl:w-[49px] right-5 top-5 md:top-6"
                      />
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizeMeal;
